export const BUTTON_VALUES = [
  'AC',
  '+/-',
  '%',
  '÷',
  '7',
  '8',
  '9',
  'x',
  '4',
  '5',
  '6',
  '-',
  '1',
  '2',
  '3',
  '+',
  '0',
  '.',
  '=',
];
export const OPERATOR_VALUES = ['÷', 'x', '+', '-', '='];
export const API_KEY = 'KWZkMBos1Jn+EJpw00r+Dg==UMwE3a2hOegwk41O';
export const API_URL = 'https://api.api-ninjas.com/v1';
